import { GetCustomerPoliciesResponse } from '@aaa-ncnu-ie/mypolicy-api-customers';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from './axios';

export const getPolicies = async (): Promise<GetCustomerPoliciesResponse> => {
  const { data } = await axios.get<GetCustomerPoliciesResponse>(
    `${import.meta.env.VITE_CUSTOMERS_API_URL}/v1/customers/policies`,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );

  return data;
};

export const usePoliciesQuery = (enabled?: boolean) =>
  useQuery({
    queryKey: ['policies'],
    queryFn: () => getPolicies(),
    staleTime: 1000 * 60 * 5,
    enabled,
  });
